import vtRequestId from '@nrdy-marketing-engine/api-fetch/src/vt-request-id';
import { track } from '@nrdy-marketing-engine/tracking';

const trackFreemiumFormInteractions = (
  category: string,
  target: string,
  label: string,
  value: string,
  metaData = {}
) => {
  try {
    return track('freemium_forms', {
      category,
      label,
      newrelicMetadata: metaData,
      request_id: vtRequestId(),
      target,
      value: value,
    });
  } catch (err) {
    typeof window !== 'undefined' && window['newrelic']?.noticeError(err);
  }
};

export default trackFreemiumFormInteractions;
